module.exports = __webpack_public_path__ + "static/media/2-8.e6956021.png";